import createLucideIcon from '../createLucideIcon';

const LogOut = createLucideIcon('LogOutIcon', [
  ['path', { d: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', key: '1uf3rs' }],
  ['polyline', { points: '16 17 21 12 16 7', key: '1gabdz' }],
  ['line', { x1: '21', y1: '12', x2: '9', y2: '12', key: '1stwgr' }],
]);

export default LogOut;
